import { Flex } from 'foundations-components/components/Flex';
import CrmListingSearchInput from 'framework-listing-lib/internal/FilterBar/components/CrmListingSearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibTableHeaderLeftSlot() {
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "100",
    alignSelf: "center",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(CrmListingSearchInput, {})
  });
}